import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { provideNgxMask } from 'ngx-mask';
import { NgxStripeModule } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';

import {
  HttpClientModule,
  provideHttpClient,
  withFetch,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ClickOutside } from './click.outside.module';
import { CLIENT_DATA_INITIALIZER } from './initializers/client-data.initializer';
import { MediaModule } from './media.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    MediaModule,
    ClickOutside,
    StoreModule.forRoot(),
    ToastrModule.forRoot({ timeOut: 3000, positionClass: 'toast-top-center' }),
    NgxStripeModule.forRoot(),
  ],
  providers: [
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch()),
    provideNgxMask(),
    CLIENT_DATA_INITIALIZER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
